import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

const CREATE_JOB = gql`
  mutation CreateJob($input: CreateJobInput!) {
    createJob(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/CreateJob').type;

export type CreateJobVariables = OperationVariables<typeof CREATE_JOB>;
export type CreateJobInput = CreateJobVariables['input'];
export type CreateJobResult = OperationData<typeof CREATE_JOB>;

export const useCreateJob = () => {
  const tuple = useMutation(CREATE_JOB);

  const [_mutate, result] = tuple;

  const mutate = (options: Parameters<typeof _mutate>[0]) => {
    if (!options.variables) {
      throw new Error('variables are required in useCreateJob');
    }
    return _mutate({
      context: { service: 'core' },
      refetchQueries: ['GetNotificationCountForUser'],
      awaitRefetchQueries: true,
      update(cache) {
        cache.evict({ fieldName: 'searchJobs' });
        cache.evict({ fieldName: 'searchTasks' });
        cache.evict({ fieldName: 'jobGetRecurrences' });
        // this might seem heavy, create one job so blow away EVERY recurrence historylist
        // but, in practice, the refetchQueries would refetch even if we hadn't executed it to start off with
        // and jobRecurrenceHistoryList is a bit slow.
        // What this means is if they go look at the history of a different job, create any job,
        // then look at the history of that first job again, it'll hit the network for it. Not a huge concern
        cache.evict({ fieldName: 'jobRecurrenceHistoryList' });
      },
      ...options,
    });
  };
  return [mutate, result] as const;
};
